import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AuthContext } from '../../../../../../context/AuthContext';

const MealBasicInfo = ({ mealid }) => {
  const [mealInfo, setMealInfo] = useState({});
  const { apiGlobal } = useContext(AuthContext);

  const fetchMealInfo = async () => {
    try {
      const res = await fetch(`${apiGlobal}meal_data_fetch.php?id=${mealid}`);
      const response = await res.json();
    //   console.log(response);
      if (response.status && response.message === 'Success') {
        setMealInfo(response.data[0]);
      } else {
        setMealInfo({});
      }
    } catch (error) {
      console.error('Error fetching meal info:', error);
    }
  };

  useEffect(() => {
    fetchMealInfo();
  }, []);

  const mealMapping = {
    1: 'Breakfast',
    2: 'Snacks',
    3: 'Lunch',
    4: 'Dinner',
  };

  return (
    <div className="container-fluid p-3">
      {/* Top row with Name, Location, Image */}
      <div className="row mb-3">
        <div className="col-md-4">
          <strong>Meal Name:</strong>
          <p>{mealInfo?.name || 'NA'}</p>
        </div>
        <div className="col-md-4">
          <h5 className="fw-semibold mb-2">Locations</h5>
          {Array.isArray(mealInfo?.locations) && mealInfo.locations.length > 0 ? (
            <ul className="ps-3 mb-0">
              {mealInfo.locations.map((loc, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                <li key={index}>{loc.location_name || 'NA'}</li>
      ))}
            </ul>
  ) : (
    <p>NA</p>
  )}
        </div>

        <div className="col-md-4 d-flex justify-content-center align-items-center">
          <img
            src={`${apiGlobal}images/meal/${mealInfo?.photo}`}
            alt="Meal"
            className="img-thumbnail"
            style={{ objectFit: 'contain', height: '200px', width: '200px' }}
          />
        </div>
      </div>

      <hr />

      <div className="row mb-3">
        <div className="col-md-4">
          <strong>Meal Price:</strong>
          <p>₹{mealInfo?.price || '0.00'}</p>
        </div>
        <div className="col-md-4">
          <strong>FOC:</strong>
          <p>{mealInfo?.foc || 'NA'} on {mealInfo?.foc_on || 'NA'}</p>
        </div>
        <div className="col-md-4">
          <strong>Meal Offered:</strong>
          <p>{mealInfo?.meal_offered
                    ?.split(',')
                    .map(mealId => mealMapping[mealId.trim()] || 'Unknown Meal')
                    .join(', ') || 'N/A'}
          </p>
        </div>
      </div>

      <hr />

      <div className="row mb-3">
        <div className="col-md-4">
          <strong>Meal Format:</strong>
          <p>
            {/* eslint-disable-next-line no-nested-ternary */}
            {mealInfo?.meal_format === '1'
                        /* eslint-disable-next-line no-nested-ternary */
      ? 'Fit'
        /* eslint-disable-next-line no-nested-ternary */
      : mealInfo?.meal_format === '2'
      ? 'Git'
      : mealInfo?.meal_format === '3'
      ? 'Delivery'
      : 'NA'}
          </p>
        </div>

        <div className="col-md-4">
          <strong>Veg / Non-Veg:</strong>
          <p>
            {/* eslint-disable-next-line no-nested-ternary */}
            {mealInfo?.veg_non_veg === '1'
                        /* eslint-disable-next-line no-nested-ternary */
      ? 'Veg'
        /* eslint-disable-next-line no-nested-ternary */
      : mealInfo?.veg_non_veg === '2'
      ? 'Non-veg'
      : mealInfo?.veg_non_veg === '3'
      ? 'Veg/Non-veg'
      : 'NA'}
          </p>
        </div>
        <div className="col-md-4">
          <strong>Cuisines:</strong>
          <p>{mealInfo?.cuisines || 'NA'}</p>
        </div>
      </div>

      <hr />

      <div className="row mb-3">
        <div className="col-md-4">
          <strong>Meal Type:</strong>
          <p>{mealInfo?.meal_type || 'NA'}</p>
        </div>
        <div className="col-md-4">
          <strong>Description:</strong>
          <p>{mealInfo?.description || 'NA'}</p>
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <strong>Start Date:</strong><p>{mealInfo?.start_date || 'NA'}</p>
          </div>
          <div className="d-flex">
            <strong>End Date:</strong><p>{mealInfo?.end_date || 'NA'}</p>   
          </div>
        </div>
      
      </div>
      <hr />

      <div className="row mt-4">
        <div className="col-12">
          <h5>Meal Items</h5>
          <div
            className="table-responsive mt-2"
            style={{ maxHeight: '250px', overflowY: 'auto', border: '1px solid #dee2e6' }}
          >
            <table className="table table-bordered mt-2">
              <thead className="bg-primary text-white sticky-top">
                <tr>
                  <th>Item Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {JSON.parse(mealInfo.items || '[]').map((item, index) => (

                    // eslint-disable-next-line react/no-array-index-key
                  <tr key={index}>
                    <td>{item?.name}</td>
                    <td>{item?.description}</td>
                  </tr>
        ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

MealBasicInfo.propTypes = {
  mealid: PropTypes.string.isRequired,
};

export default MealBasicInfo;
